import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Loader from '@spothero/ui/loader';
import Portal from '@spothero/ui/portal';
import DOMUtils from '@spothero/utils/dom';
import withConfig from 'config/withConfig';

const PurchasingOverlay = ({isMobile, showContent}) => {
    useEffect(() => {
        DOMUtils.addClass('html', 'PurchasingOverlay-showing');

        return () => {
            DOMUtils.removeClass('html', 'PurchasingOverlay-showing');
        };
    }, []);

    return (
        <Portal>
            <div className="PurchasingOverlay">
                {showContent && (
                    <div className="PurchasingOverlay-content">
                        <Loader
                            size={isMobile ? 64 : 80}
                            borderWidth={isMobile ? 8 : 10}
                        />
                        <p>Confirming your reservation...</p>
                        <small>
                            We&apos;re processing your payment and sending you a
                            confirmation email.
                        </small>
                    </div>
                )}
            </div>
        </Portal>
    );
};

PurchasingOverlay.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    showContent: PropTypes.bool,
};

PurchasingOverlay.defaultProps = {
    showContent: true,
};

export default withConfig(['isMobile'])(PurchasingOverlay);
